import { type } from 'arktype';
import { baseJunctionQuerySchema, baseJunctionCreateSchema, BaseJunction } from './shared';

/**
 * Query schema for filtering calendar-location associations
 */
export const calendarLocationQuerySchema = baseJunctionQuerySchema
  .and(
    type({
      'locationId?': type('string').configure({
        description: 'Filter associations by the linked location ID.',
        examples: ['loc_018ef4a2'],
      }),
    })
  )
  .configure({ description: 'Query parameters for listing calendar-to-location associations.' });
export type CalendarLocationQuery = typeof calendarLocationQuerySchema.t;

/**
 * Schema for creating a calendar-location association
 */
export const createCalendarLocationSchema = baseJunctionCreateSchema
  .and(
    type({
      locationId: type('string').configure({
        description: 'ID of the location the calendar is being associated with.',
        examples: ['loc_018ef4a2'],
      }),
    })
  )
  .configure({ description: 'Payload for linking a factory calendar to a location.' });
export type CreateCalendarLocation = typeof createCalendarLocationSchema.t;

/**
 * Calendar-Location association response DTO
 */
export interface CalendarLocation extends BaseJunction {
  locationId: string;
}
